export const CSRF_COOKIE_NAME = 'ct_csrf'
export const CSRF_HEADER_NAME = 'X-CSRF-Token'

export function getCsrfTokenFromCookie(): string | null {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${CSRF_COOKIE_NAME}=([^;]*)`))
  if (!match?.[1]) return null
  try {
    return decodeURIComponent(match[1])
  } catch {
    return match[1]
  }
}

export function getCookieAuthHeaders(): Record<string, string> {
  const csrfToken = getCsrfTokenFromCookie()
  return csrfToken ? { [CSRF_HEADER_NAME]: csrfToken } : {}
}
